import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './PageProfile.css';
import MasterOperationRenderer from '../../Pages/OverlayPage/OverlayPage';

const PageProfileModal = ({ userId, operationType, profileId, mode, onClose, theme, locationId }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const handleClose = () => {
    navigate(0); // Go back to background page (e.g., home)
  };

  return (
    <div className="pp-modal-overlay">
      <div className="pp-modal-content"> 
      <button className="pp-modal-close" onClick={handleClose} style={{color: "white"}}>✕</button>
      <MasterOperationRenderer
          operationType={operationType}
          data={{userId}}
          profileId={profileId}
          mode={mode}
          setShowPopup={setShowPopup}
          locationId={locationId}
        /> 
      </div>
    </div>
  );
};

export default PageProfileModal;
